<template>
  <div class="container">
    <section class="intro-single">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="title-single-box"><h1 class="title-single">Get
              Involved</h1><span
              class="color-text-a">LASR Lab - Vanderbilt University Medical Center</span></div>
          </div>
          <div class="col-md-12 col-lg-4">
            <nav aria-label="breadcrumb" class="breadcrumb-box d-flex justify-content-lg-end">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/"
                                               class="router-link-active">Home</a></li>
                <li aria-current="page" class="breadcrumb-item active">
                  Get Involved
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <section class="section-donate">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-t1"><h3>Follow us on Social Media</h3>
            <div class="social-media"><a href="http://facebook.com/AutismLASR"><i
              class="fa fa-facebook-square fa-2x"></i></a><a
              href="https://twitter.com/AutismLASR"><i
              class="fa fa-twitter-square fa-2x"></i></a></div>
            <div class="Participate"><h3>Participate in other Research</h3>
              <p>Visit Vanderbilt Kennedy Center's StudyFinder to search for studies that are currently recruiting interested volunteers. <li><a href="https://vkc.vumc.org/studyfinder/">StudyFinder</a></li>

              <p>Join the Autism Research Registry, which aids Vanderbilt Kennedy Center researchers in connecting with individuals on the autism spectrum and families who are willing to participate in research. <li><a href="https://redcap.vanderbilt.edu/surveys/?s=F9NEE4DFXX">Autism Registry</a></li> </p></div?>

            <div class="donate"><h3>Donate to the Lab</h3>
              <p>Vanderbilt encourages designation of donations to support specific endeavors that
                are
                a
                priority for the donor. If you would like to support research in the LASR Lab by
                giving to the Vanderbilt Fund, please follow these steps:</p>
              <ol>
                <li><a
                  href="https://give.vanderbilthealth.org/give/230214/?utm_source=VHGiving&amp;utm_medium=website&amp;utm_campaign=CascioLab#!/donation/checkout?c_src=M19DZ&amp;c_src2=CV11">Visit
                  the
                  Vanderbilt Fund giving page</a>.
                </li>
                <li>In the first drop-down box (area you would like to support"), choose "other".
                </li>
                <li>In the "Allocation Description" box, type <strong>Carissa
                  Cascio Research
                  Laboratory</strong></li>
              </ol>
              <p>Thank you for your support!</p></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "GetInvolved"
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GetInvolved.vue